import React from 'react';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import {FavoriteButton} from 'components/partials/favorite-button';
import {ShoppingCartButton} from 'components/partials/shopping-cart-button';
import {SendRequestButton} from 'components/partials/send-request-button';
import {ShowIf} from 'components/utils';
import style from './style.scss';
import {connect} from 'react-redux';
import {getPrice} from 'lib/convert';

class ProductInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      time: ''
    }
  }

  componentDidMount() {
    if(this.props.SystemInfo && this.props.SystemInfo.endDate) {
      this.countDown(this.props.SystemInfo.endDate)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.SystemInfo !== this.props.SystemInfo && this.props.SystemInfo.endDate) {
      this.countDown(this.props.SystemInfo.endDate)
    }
  }

  countDown(endTime) {
    if (endTime && this.wrap) {
      var dateEntered = new Date(endTime);
      var now = new Date();
      var difference = dateEntered.getTime() - now.getTime();

      if (difference <= 0) {
        return
      } else {

        var seconds = Math.floor(difference / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours %= 24;
        minutes %= 60;
        seconds %= 60;
        let self = this;
        setTimeout(function() {
          self.countDown(endTime);
        }, 1000)
        this.setState({
          time: `Còn ${days + ' ngày ' + (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)}`
        })
      }
    }
  }

  render() {
    let { name, description, business, promotionalPrice, price, id, auth, from, averageRatingPoint, totalRatingTimes, isOnlyApplyPromotionalPriceFair } = this.props
    // the final price will be equal to promotionalPrice or price of the product
    const finalPrice = promotionalPrice || price;
    // the price and promotionalPrice are numbers, the promitionPrice is smaller than the price
    const isHasDifferencePrice = typeof getPrice(price, null) === 'number' &&
      typeof getPrice(promotionalPrice, null) === 'number' &&
      getPrice(price, null) - getPrice(promotionalPrice, null) > 0;
    // check condition to show countdown
    const isShowCountdown = isOnlyApplyPromotionalPriceFair && isHasDifferencePrice;
    return (
      <section className="product-info" ref={(wrap) => this.wrap = wrap}>
        <h2 className="product-title">{name}</h2>
        <p className="product-description">{description}</p>
        {
          business &&
          <div className="conpany-wrap">
            <div className="company-image-wrap">
              <UploadImage transform="crop" type="BUSINESS" width="45" height="42" image={business && business.logo} />
            </div>
            <p className="company-name">{business && business.name}</p>
            <p className="view-info">
              <Link to={`/doanh-nghiep/${business && business.nameSlug}`} className="view-info-link">Xem thông tin doanh nghiệp</Link>
            </p>
          </div>
        }
        <ShowIf condition={from}>
          <p className="product-from"><strong>Xuất xứ</strong>:
            <span>&nbsp;{from}</span>
          </p>
        </ShowIf>
        <ShowIf condition={auth.isAuthenticated}>
          <p className="product-phone"><strong>Gọi</strong>:
            <a href={`tel:${business && business.phone}`}>&nbsp;{business && business.phone}</a>
          </p>
        </ShowIf>
        <ShowIf condition={typeof getPrice(finalPrice, null) === 'number' && getPrice(finalPrice, null) > 0}>
          <p className="product-price">Giá: <span className="price">{getPrice(finalPrice)}</span></p>
        </ShowIf>
        <ShowIf condition={typeof getPrice(finalPrice, null) !== 'number'}>
          <p className="product-price">Giá: <span className="price">Giá tham khảo</span></p>
        </ShowIf>
        {isShowCountdown && (<p className='price mb15'>{this.state.time}</p>)}
        <FavoriteButton productId={id} averageRatingPoint={averageRatingPoint} totalRatingTimes={totalRatingTimes}/>
        <div className="wrap-button">
          <ShowIf condition={typeof getPrice(finalPrice, null) === 'number'}>
            <ShoppingCartButton productId={id} isDetail={true} />
          </ShowIf>
          <ShowIf condition={typeof getPrice(finalPrice, null) !== 'number'}>
            <SendRequestButton productId={id} isDetail={true} />
          </ShowIf>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {auth: state.auth, SystemInfo: state.System.data || {}};
};

export default connect(mapStateToProps)(ProductInfo);



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/product-info/ProductInfo.jsx